import {PartyType} from '@sollapay/enums';

import {
  BuyerEntrySchema,
  OrganizationEntrySchema,
  SignatoryEntrySchema
} from '@/features/buyers/validation';

import {mergeBuyerWithDefaults} from './buyer-defaults.utils';

import type {BuyerEntryFormValues} from '@/features/buyers/validation';

export interface BuyerEntrySummary {
  name: string;
  /** Distinct fields that are missing or invalid on the branch (person or organization) that will actually be submitted. */
  issues: number;
}

type ParseResult = {error?: {issues: {path: PropertyKey[]}[]}};

export function summarizeBuyerEntry(entry: BuyerEntryFormValues): BuyerEntrySummary {
  const row = mergeBuyerWithDefaults(entry);

  if (row.partyType === PartyType.ORGANIZATION) {
    const invalidFields = new Set([
      ...invalidFieldPaths('organization', OrganizationEntrySchema.safeParse(row.organization)),
      ...row.signatories.flatMap((signatory, i) =>
        invalidFieldPaths(`signatories.${i}`, SignatoryEntrySchema.safeParse(signatory))
      )
    ]);
    return {name: row.organization.companyName.trim(), issues: invalidFields.size};
  }

  const invalidFields = new Set(
    invalidFieldPaths('person', BuyerEntrySchema.safeParse(row.person))
  );
  return {name: row.person.fullName.trim(), issues: invalidFields.size};
}

// One field can fail several rules (empty email fails both "required" and "format"), so callers dedupe by path.
function invalidFieldPaths(scope: string, result: ParseResult): string[] {
  return (result.error?.issues ?? []).map(issue => `${scope}.${issue.path.map(String).join('.')}`);
}
